import { RuleObject } from 'antd/lib/form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import i18n from '~/i18n';
import { basicValidation } from './basicValidation';

export type Validator = RuleObject['validator'];

/**
 * Phone validator that automatically adds a country code prefix before validation.
 * Use this for phone input fields that have a fixed country code addonBefore.
 * 
 * @param countryCode - The country code to add (default: '966' for Saudi Arabia)
 * @returns Validator function for Ant Design Form
 */
export const createPhoneValidatorWithPrefix = (countryCode: string = '966'): Validator => {
    return basicValidation((rule, value, callback) => {

        try {
            if (!value) {
                callback();
                return;
            }

            // Add country code prefix if not already present
            let normalizedValue = value;
            if (!value.startsWith('+')) {
                normalizedValue = `+${countryCode}${value}`;
            }

            console.log('normalizedValue', normalizedValue);
            const phoneNumber = parsePhoneNumberFromString(normalizedValue);
            if (!phoneNumber?.isPossible) {
                throw new Error(i18n.t('Invalid number', { ns: 'validation' }));
            }
            if (normalizedValue.length < 12) {
                throw new Error(i18n.t('Invalid number', { ns: 'validation' }));
            }
            callback();
        } catch (err) {
            console.log((err as any).message as string);
            callback((err as any).message as string);
        }
    });
};

/**
 * Default phone validator with +966 prefix for Saudi Arabia
 */
const phoneValidationWithPrefix: Validator = createPhoneValidatorWithPrefix('966');

export default phoneValidationWithPrefix;
